import {
  EDIT_EVENT_AUDIOS,
  EDIT_EVENT_AUDIO_HTML,
  REMOVE_EVENT_AUDIO,
  RECEIVE_AUDIOS_URLS,
} from '../../constants/ActionTypes';
import editEventContent from '../../functions/event/editEventContent';
import { findEvent, copyQuest, touchQuestModified } from '../questsHelpers';

/**
 * Handles audio-related event actions.
 * @param {Object} state - current state of quests slice
 * @param {Object} action - dispatched Redux action
 * @returns {Object|null}
 */
export default function eventAudioReducer(state, action) {
  let nextQuest;

  switch (action.type) {
    case RECEIVE_AUDIOS_URLS: {
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = (nextQuest.events || []).find(
        (e) => String(e.id) === String(action.eventId)
      );
      if (!event) return state;
      const audios = {
        contentType: 'audio',
        visible: true,
        data: action.audios,
        autoplay: true,
      };
      if (!event.content) {
        event.content = [audios];
      } else {
        const currentAudios = event.content.filter(
          (item) => item.contentType === 'audio'
        );
        if (currentAudios.length) {
          const [firstAudio] = currentAudios;
          event.content = event.content.filter(
            (item) => item.contentType !== 'audio'
          );
          const currentData = firstAudio.data;
          audios.data = audios.data.concat(currentData);
          audios.html = firstAudio.html;
          event.content = [...event.content, audios];
        } else if (audios.data) {
          event.content = [...event.content, audios];
        }
      }

      touchQuestModified(nextQuest);

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case REMOVE_EVENT_AUDIO: {
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = (nextQuest.events || []).find(
        (e) => String(e.id) === String(action.eventId)
      );
      if (event && event.content) {
        const currentAudios = event.content.find(
          (item) => item.contentType === 'audio'
        );
        if (currentAudios) {
          currentAudios.data = currentAudios.data.filter(
            (mp3, i) => i !== action.audioId
          );
          event.content = event.content.filter(
            (item) => item.contentType !== 'audio'
          );
          event.content = [...event.content, currentAudios];
        }
      }

      touchQuestModified(nextQuest);

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case EDIT_EVENT_AUDIOS: {
      const { questId, eventId, autoplay } = action;
      let { visible } = action;
      nextQuest = copyQuest(state, questId);
      if (!nextQuest) return state;
      const event = findEvent(nextQuest.events, eventId);
      if (event && event.content) {
        const currentAudios = event.content.find(
          (item) => item.contentType === 'audio'
        );
        if (visible === undefined && currentAudios) {
          visible = Boolean(currentAudios.data.length);
        }
        if (currentAudios) {
          event.content = event.content.map((item) => {
            if (item.contentType !== 'audio') return item;
            return {
              ...currentAudios,
              visible,
              autoplay,
            };
          });
        } else {
          const audioItem = {
            contentType: 'audio',
            visible: false,
            data: [],
            autoplay: true,
          };
          event.content = [...event.content, audioItem];
        }
      }

      touchQuestModified(nextQuest);

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === questId ? nextQuest : quest
        ),
      };
    }

    case EDIT_EVENT_AUDIO_HTML: {
      const { html } = action;
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = findEvent(nextQuest.events, action.eventId);
      if (event) {
        event.content = editEventContent(event.content, 'audio', (audio) => ({
          ...audio,
          html,
        }));
      }

      touchQuestModified(nextQuest);

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    default:
      return null;
  }
}
